import { EntityType, ISourceInfo, PpmxConnection, SourceInfo, ppmxTaskConnectionId } from '../../entities/common';
import { urlParamsBuilder } from '../../entities/Subentities';
import type * as ProjectsListStore from '../../store/ProjectsListStore';

/**
 * Which connection and which view the task list URL is pointing at. Kept out of the component so the rule below can
 * be exercised without its render-side module graph.
 */
type TaskViewLocation = {
    entity?: ProjectsListStore.ProjectInfo;
    location: { search: string };
};

export function getSourceInfoFromUrl(entity: ProjectsListStore.ProjectInfo | undefined, location: any): ISourceInfo<any> {
    if (!entity) {
        return PpmxConnection;
    }
    const query = new URLSearchParams(location.search);
    const connectionId = query.get(urlParamsBuilder.connectionId);
    const sourceInfo = SourceInfo.getSyncableConnections(entity.sourceInfos).find(_ => !SourceInfo.isCollaborative(_) && _.connectionId === connectionId);
    return connectionId && connectionId !== ppmxTaskConnectionId && sourceInfo
        ? sourceInfo
        : PpmxConnection;
}

export function getViewTypeFromUrl(entity: ProjectsListStore.ProjectInfo | undefined, location: any): string | undefined {
    const query = new URLSearchParams(location.search);
    const viewType = query.get(urlParamsBuilder.viewType(EntityType.Task));
    return viewType?.toLowerCase();
}

/**
 * Whether the Workload grid is now looking at a different set of by-day rows. Those rows are fetched per CONNECTION
 * as much as per view, and the "View PPM Express Tasks" button switches the connection WITHOUT leaving the view - so
 * a view-type check on its own never fired here, and the grid kept showing the previous connection's distribution
 * until the page was reloaded by hand.
 */
export function isWorkloadSourceChanged(props: TaskViewLocation, nextProps: TaskViewLocation): boolean {
    if (!props.entity || !nextProps.entity) {
        return false;
    }

    return getViewTypeFromUrl(props.entity, props.location) !== getViewTypeFromUrl(nextProps.entity, nextProps.location)
        || getSourceInfoFromUrl(props.entity, props.location).connectionId !== getSourceInfoFromUrl(nextProps.entity, nextProps.location).connectionId;
}
